import React from "react";
import { PureComponent } from "react";
import {
  FormGroup,
  Table,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";
import { Link } from "react-router-dom";
import moment from "moment";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
class AdvPayForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  render() {
    return (
      <div>
        <div className="d-flex align-items-center justify-content-around mb-4">
          <button
            type="button"
            className="btn btn-default"
            style={{ flex: 1 }}
            disabled={this.props.loading || this.props.data.payment_amount}
            onClick={this.props.submitArticle}
          >
            付費
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            style={{ flex: 1 }}
            disabled={this.props.loading}
            onClick={this.props.editArticle}
          >
            保存修改
          </button>
        </div>
        <p>
          預計價格：$
          {this.props.data.position === "top"
            ? 20 * this.props.data.weeks
            : 10 * this.props.data.weeks}
          + tax
        </p>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            標題
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.title}
            onChange={e => this.props.onTextInputChange(e, "title")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            廣告類別
          </label>
          <p>
            {this.props.data.post
              ? this.props.data.post.categories[0].display_name
              : ""}
          </p>
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            廣告位置
          </label>
          <p>{this.props.data.position === "top" ? "頂部" : "側邊"}</p>
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            周長
          </label>
          <p>{this.props.data.weeks}</p>
        </FormGroup>
      </div>
    );
  }
}

export default AdvPayForm;
